import * as actionTypes from '../actions/ActionTypes';

const initialCommonState = {
  topicList: [],
  subtopicList: [],
  questionList: [],
  showTopicList: true,
};

const QuestionReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MAIN_TOPICS:
      return {
        ...state,
        topicList: action.mainTopicsArray,
        showTopicList: true,
      };
    case actionTypes.SHOW_SUB_TOPICS:
      return {
        ...state,
        subtopicList: action.subTopicsArray,
        showTopicList: false,
      };
    case actionTypes.LIST_OF_QUESTIONS:
      return {
        ...state,

        questionList: action.questionArray,
      };
    case actionTypes.LOGOUT:
      return { ...initialCommonState };

    default:
      return state;
  }
};

export default QuestionReducer;
